<div class="flowchart-tile-form">
  <div class="row">
    <select-search-component
        [api_model]="'process'"
        [label]="'Process'"
        [value]="config.process"
        (selectionChange)="onProcessChange($event.value)"
        [classes]="'fill'" class="select-search"
    ></select-search-component>
  </div>

  <div class="row center">
    <mat-form-field>
      <mat-label>Scale (%)</mat-label>
      <input [(ngModel)]="config.scale" matInput max="500" min="10" step="1" type="number"
             name="scale">
      <mat-hint>Adjust the zoom level for the view of the flowchart. This works together with the rowspan and
        colspan to determine the size and proportion of the flowchart that will be seen on the dashboard.
        (A scale of 100 will show the full flowchart in the dashboard tile created.)
      </mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Left Offset (px)</mat-label>
      <input [(ngModel)]="config.left_offset" matInput max="1000" min="0" type="number"
             name="left_offset">
      <mat-hint>Adjust the left hand starting point when viewing a zoomed in proportion of a flowchart.
      </mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Top Offset (px)</mat-label>
      <input [(ngModel)]="config.top_offset" matInput max="1000" min="0" type="number"
             name="top_offset">
      <mat-hint>Adjust the top starting point when viewing a zoomed in proportion of a flowchart.</mat-hint>
    </mat-form-field>
    <mat-checkbox [(ngModel)]="hideScroll" (change)="onHideScrollChange($event)"
                  name="hide_scroll" class="form-element-align">Hide scroll bar
    </mat-checkbox>

  </div>
</div>
